
import { Route, Routes, useLocation } from 'react-router-dom';
import './App.css'; 
import Login from './components/login/Login';
import SideBar from './components/SideBar';
import Header from './components/Header';
import { useState } from 'react';
import Members from './components/members/Members';
import MastersEducationOccupation from './components/MastersEducationOccupation';
import Dashboard from './components/dashboard/Dashboard';
import { PrivateRoute } from './components/PrivateRoute'; 
import Users from './components/Users';
import Role from './components/Role';
import MastersLocation from './components/MastersLocation';
import MasterSkills from './components/MasterSkills';
import MastersDesignation from './components/MastersDesignation';
import ReportsEducationOccupation from './components/ReportsEducationOccupation';
import ScrollToTop from './components/ScrollToTop';
import AddMembers from './components/members/addMembers/AddMembers';

function App() {

  const [showSideBar, setShowSideBar] = useState(false) 
 
  const location = useLocation();
  const isActiveLink = (link) => {
    return link === location.pathname;
  };
  return (
    <div className="App">
      {/* <Navbar/> */}
      <Header />
      <div style={{ height: '80px' }}></div>
      <div class='d-flex  gap-1'> 
        {!isActiveLink('/log-in') &&
          <SideBar /> 
        }
        <div style={{ width: '100%' }}>

            <ScrollToTop/>
          <Routes>
            <Route path='/log-in' element={<Login />} />
            <Route path='/' element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path='/members' element={<PrivateRoute><Members /></PrivateRoute>} />
            <Route path='/add-members' element={<PrivateRoute><AddMembers /></PrivateRoute>} />

            <Route path='/masters-education-occupation' element={<PrivateRoute><MastersEducationOccupation /></PrivateRoute>} />
            <Route path='/masters-location' element={<PrivateRoute><MastersLocation /></PrivateRoute>} />
            <Route path='/masters-skills' element={<PrivateRoute><MasterSkills /></PrivateRoute>} />
            <Route path='/masters-designation' element={<PrivateRoute><MastersDesignation /></PrivateRoute>} />
            <Route path='/reports-education-occupation' element={<PrivateRoute><ReportsEducationOccupation /></PrivateRoute>} />
            <Route path='/users' element={<PrivateRoute><Users /></PrivateRoute>} />
            <Route path='/role' element={<PrivateRoute><Role /></PrivateRoute>} />  
          </Routes>
        </div>
      </div>



    </div>
  );
}

export default App;
